module.exports = __webpack_public_path__ + "static/media/Artboard 1 copy 75300.f4289fb1.png";